module.exports = __webpack_public_path__ + "media/2022/FAFSA-callout-9a6864b3.png";